<template>
  <v-row class="fill-height">
    <v-col>
      <v-sheet height="64">
        <v-toolbar flat>
          <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday"
            >Сегодня</v-btn
          >
          <v-btn fab text small color="grey darken-2" @click="prev">
            <v-icon small>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn fab text small color="grey darken-2" @click="next">
            <v-icon small>mdi-chevron-right</v-icon>
          </v-btn>
          <v-toolbar-title v-if="$refs.calendar">{{
            $refs.calendar.title
          }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="modal = true"
            >
            <v-icon>mdi-plus-circle-outline</v-icon></v-btn
          >
        </v-toolbar>
      </v-sheet>
      <v-sheet>
        <v-calendar
          ref="calendar"
          v-model="focus"
          color="primary"
          event-end="end_at"
          event-start="start_at"
          :events="entities"
          :event-color="getEventColor"
          @click:event="showEvent"
          @change="updateRange"
        >
          <template #event="{event}">
            <div class="event-row">{{ event.name }}</div>
          </template>
        </v-calendar>
        <VDialog v-model="modal" v-if="modal" class="entity-modal">
          <MilestoneDetail
            showDeleting
            @change="fetchMilestones"
            @create="fetchMilestones"
            title="этап"
            class="modal-entity"
            :predefinedValues="{
              milestoneable_id,
              milestoneable_type,
            }"
            use-prop
            :id="
              !Object.keys(selectedMilestone).length
                ? null
                : selectedMilestone.id.toString()
            "
          />
        </VDialog>
      </v-sheet>
    </v-col>
  </v-row>
</template>
<script>
import { mapActions } from 'vuex';
import colorHash from 'color-hash';
export default {
  components: {
    MilestoneDetail: () => import('@/views/Milestone/MilestoneDetail.vue'),
  },
  props: {
    milestoneable_id: {
      type: Number,
    },
    milestoneable_type: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    focus: '',
    type: 'month',
    typeToLabel: {
      month: 'Месяц',
      week: 'Неделя',
      day: 'День',
    },
    entities: [],
    selectedMilestone: {},
    selectedElement: null,
    selectedOpen: false,
    events: [],
    hash: null,
    modal: false,
  }),
  async mounted() {
    this.hash = new colorHash();
    this.$refs.calendar.checkChange();
  },
  watch: {
    async milestoneable_id() {
        await this.fetchMilestones()
    },
  },
  methods: {
    ...mapActions('milestone', ['getEntities']),
    async fetchMilestones() {
      if (this.milestoneable_id !== null){
        this.entities = await this.getEntities({
          milestoneable_id: this.milestoneable_id,
          milestoneable_type: this.milestoneable_type,
        });
        if(this.modal) this.modal = false
      }
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = 'day';
    },
    getEventColor(milestone) {
      return this.hash ? this.hash.hex(milestone.id) : '#00bcd4';
    },
    setToday() {
      this.focus = '';
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      this.selectedMilestone = event;
      this.modal = true;
      nativeEvent.stopPropagation();
    },
    updateRange({ start, end }) {
      const events = [];
      const min = new Date(`${start.date}T00:00:00`);
      const max = new Date(`${end.date}T23:59:59`);
    },
  },
};
</script>
